const dns_retrieve_domain_records_dialog = {
	description:
		"Enter the domain name whose existing DNS records you want to retrieve here. Some records may be missing here.",

	domain_search_input: {
		label: "Domain name",
		placeholder: "e.g. 'codebee.com'",
	},
	message: {
		success: "The DNS records have been added successfully.",
	},
	search_button: {
		label: "Fetch records",
	},
	submit_button: {
		label: "Add ({{record_selected_count}} records)",
	},
	title: "DNS retrieve external domain",
};

export default dns_retrieve_domain_records_dialog;
